import { MediaType } from '@brightmls/nextgen.lae.mediacenter';

export const MEDIA_CONSTRAINTS = {
  getEnabledTypes: (isResoSystem: boolean): MediaType[] => {
    const types: MediaType[] = [MediaType.Photo, MediaType.Document];
    if (isResoSystem) {
      types.push(MediaType.Tour);
    }

    return types;
  },

  getCategoryMapping: (isResoSystem: boolean) => {
    return {
      photos: ['Photo'],
      documents: isResoSystem ? ['Document', 'Floor Plan'] : ['Document'],
      tours: isResoSystem ? ['Tours'] : [],
    };
  },

  limits: {
    photos: {
      maxCount: 50,
      fileConstraints: {
        maxSizeBytes: 20 * 1024 * 1024, // 20MB
        minSizeBytes: 1024, // 1KB
        allowedFormats: ['jpg', 'jpeg'],
        minWidth: 10,
        minHeight: 10,
        recommendedWidth: 1920,
        recommendedHeight: 1080,
        maxFileNameLength: 50,
        maxResizeWidth: 2048,
        maxResizeHeight: 1536,
        jpegQuality: 0.85,
      },
    },
    documents: {
      maxCount: 20,
      fileConstraints: {
        maxSizeBytes: 20 * 1024 * 1024,
        minSizeBytes: 1 * 1024,
        allowedFormats: ['pdf'],
        maxFileNameLength: 50,
      },
    },
    tours: {
      maxCount: 20,
      fileConstraints: {
        maxSizeBytes: 20 * 1024 * 1024,
        allowedFormats: ['html', 'zip'],
        maxFileNameLength: 50,
      },
    },
  },
} as const;
